import { store } from '@/store'
// import { LoremIpsum } from 'lorem-ipsum'
/**
 * This should add a test goal collection to the database
 * It should first add a goal-collection
 * then add a goal-collection-translation to the goal-collection
 * then add 15 goal-collections-sub-categories to the goal-collection
 */
/*
const testGoals = [
  {
    title: 'Test Goal 1',
    description: 'Test Goal 1 Description',
    rating: 1,
    subCategoryId: 1,
  },
  {
    title: 'Test Goal 2',
    description: 'Test Goal 2 Description',
    rating: 2,
    subCategoryId: 2,
  },
  {
    title: 'Test Goal 3',
    description: 'Test Goal 3 Description',
    rating: 3,
    subCategoryId: 3,
  },
  {
    title: 'Test Goal 4',
    description: 'Test Goal 4 Description',
    rating: 4,
    subCategoryId: 4,
  },
  {
    title: 'Test Goal 5',
    description: 'Test Goal 5 Description',
    rating: 5,
    subCategoryId: 5,
  },
] */

export default async function seedTestCollection (disable = false) {
  console.log('seedTestCollection', disable)
  if (disable) return null
  // add a goal-collection
  const goalCollection = await store.dispatch('goal-collections/create', {
    title: 'Test Goal Collection22',
    description: 'Test Goal Collection Description',
    frameworkId: 1,
    countryId: 1,
    organizationId: 1,
    visibility: 'public',
    isEnabled: true,
  })
  // add a goal-collection-translation to the goal-collection
  await store.dispatch('goal-collections-translations/create', {
    title: 'Test Goal Collection',
    description: 'Test Goal Collection Description',
    goalCollectionId: goalCollection.id,
    localeId: 1,
  })
  /* const response = await store.dispatch('categories/find', {
    query: {
      frameworkId: 1,
    },
  })
  const categories = response.data
  const subCategoriesResponse = await store.dispatch('sub-categories/find', {
    query: {
      categoryId: { $in: categories.map(category => category.id) },
    },
  })
  const lorem = new LoremIpsum({
    sentencesPerParagraph: {
      max: 8,
      min: 4,
    },
    wordsPerSentence: {
      max: 16,
      min: 4,
    },
  })
  const subCategories = subCategoriesResponse.data
  subCategories.forEach(async (subCategory) => {
    const isEnabled = Math.random() < 0.5
    const rating = Math.floor(Math.random() * 100) + 1
    const title = subCategory.title
    const description = lorem.generateParagraphs(1)
    await store.dispatch('goal-collections-sub-categories/create', {
      goalCollectionId: goalCollection.id,
      subCategoryId: subCategory.id,
      rating: rating,
      title: title,
      description: description,
      isEnabled: isEnabled,
    })
  }) */
  return null
}
